import { env } from "./env";

export const AppConfig = {
  backendUrl: env.backendUrl,
};
